import React, { useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  background-color: #eee;
`;

const StyledSection = styled.div``;

export default ({ fluid, children }) => {
  return (
    <Wrapper>
      <StyledSection className={"container"}>{children}</StyledSection>
    </Wrapper>
  );
};
